import { get } from "lodash";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { KEYS } from "utils/constants";
import Loader from "../Components/Loader";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const ElectronicSignature = ({
  project,
  onNext,
  onBack,
  updateUrl,
  currentStatus,
  tracer,
}) => {
  const subscriptionId =
    localStorage.getItem(KEYS.SUBSCRIPTION_ID) ||
    get(project, "fields.currentSubscription");
  const { data, loading } = useQuery(graphql.queries.SUBSCRIPTION, {
    fetchPolicy: "no-cache",
    variables: { where: { id: subscriptionId } },
  });
  const [updateSubscription] = useMutation(
    graphql.mutations.UPDATE_SUBSCRIPTION,
    {
      variables: { where: { id: subscriptionId }, data: { locked: true } },
    },
  );
  const signatureLink = get(data, "subscription.signature.signatureLink");

  if (loading || !signatureLink) return <Loader />;

  const next = (_ = {}) => {
    updateSubscription();
    const source = localStorage.getItem(KEYS.SOURCE);
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    onNext({ payload: {} });
  };

  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        tracer={tracer}
        showProfile={false}
      />
      <View
        onNext={next}
        user={get(project, "contact.user")}
        onBack={onBack}
        signatureLink={signatureLink}
      />
    </>
  );
};

export default ElectronicSignature;
